import { inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Observable } from 'rxjs'
// Direkt aus der Datei, nie aus `../components`: dieser Guard haengt am Start der App, und der
// Barrel zog darueber Zusteller-Logos und Unterschriftenfeld ins Initial-Bundle (libs/shared/CLAUDE.md).
import { YesNoDialogComponent, YesNoDialogModel } from '../components/yes-no-dialog/yes-no-dialog.component'
import { DirtyFormCanDeactivateGuard } from './dirty-form.guards'

/**
 * Ask the user if they want to discard the form
 * @returns Observable<boolean> - true if the user wants to discard the form, false otherwise
 */
export function askToDiscardForm(): Observable<boolean> {
  const dialog = inject(MatDialog)

  // Open a dialog to confirm the user wants to discard changes
  return dialog
    .open(YesNoDialogComponent, {
      data: <YesNoDialogModel>{
        title: 'Änderungen verwerfen?',
        question: 'Möchtest du die Änderungen verwerfen?',
      },
      disableClose: true,
    })
    .afterClosed()
}

export abstract class DirtyFormCanDeactivateGuardAdapter implements DirtyFormCanDeactivateGuard {
  abstract isDirty(): boolean

  askToDiscardForm(): Observable<boolean> {
    return askToDiscardForm()
  }
}
